import { render } from "./BaseAudioElement.vue?vue&type=template&id=68c415ea&scoped=true&ts=true"
import script from "./BaseAudioElement.vue?vue&type=script&lang=ts"
export * from "./BaseAudioElement.vue?vue&type=script&lang=ts"

import "./BaseAudioElement.vue?vue&type=style&index=0&id=68c415ea&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c415ea"]])

export default __exports__